import React from 'react'
import { GOOD_WEATHER_CONDITIONS } from '../options'

export const getTableTotalsData = ({
  morningMissions,
  lunchMissions,
  afternoonMissions,
  morningMissionsPercentage,
  lunchMissionsPercentage,
  afternoonMissionsPercentage,
}) => [
  [
    {
      label: 'Total Missions on a time slot:',
      xs: 5,
      align: 'flex-end',
      type: 'label',
    },
    {
      label: morningMissions,
      xs: 1,
      type: 'number',
    },
    {
      label: lunchMissions,
      xs: 1,
      type: 'number',
    },
    {
      label: afternoonMissions,
      xs: 1,
      type: 'number',
    },
    {
      label: null,
      xs: 1,
      type: null,
    },
  ],
  [
    {
      label: 'Percentages:',
      xs: 5,
      align: 'flex-end',
      type: 'label',
    },
    {
      label: `${morningMissionsPercentage}%`,
      xs: 1,
      type: 'string',
    },
    {
      label: `${lunchMissionsPercentage}%`,
      xs: 1,
      type: 'string',
    },
    {
      label: `${afternoonMissionsPercentage}%`,
      xs: 1,
      type: 'string',
    },
    {
      label: null,
      xs: 1,
      type: null,
    },
  ],
]

const interpolateColor = (color1, color2, factor) => {
  const hex1 = color1.replace('#', '')
  const hex2 = color2.replace('#', '')

  const r1 = parseInt(hex1.substr(0, 2), 16)
  const g1 = parseInt(hex1.substr(2, 2), 16)
  const b1 = parseInt(hex1.substr(4, 2), 16)

  const r2 = parseInt(hex2.substr(0, 2), 16)
  const g2 = parseInt(hex2.substr(2, 2), 16)
  const b2 = parseInt(hex2.substr(4, 2), 16)

  const r = Math.round(r1 + (r2 - r1) * factor)
  const g = Math.round(g1 + (g2 - g1) * factor)
  const b = Math.round(b1 + (b2 - b1) * factor)

  return `#${r.toString(16).padStart(2, '0')}${g
    .toString(16)
    .padStart(2, '0')}${b.toString(16).padStart(2, '0')}`
}

export const getCvrGradientStyles = (cvr, percentiles, rowStyles) => {
  const { p5, p25, p50, p75, p95 } = percentiles

  const gradientPoints = [
    { value: p5, bg: '#FFCECA', border: '#FF5448' },
    { value: p25, bg: '#FFE5A3', border: '#E6B366' },
    { value: p50, bg: '#FFFD93', border: '#F0C075' },
    { value: p75, bg: '#C8F5A8', border: '#A3D67A' },
    { value: p95, bg: '#D1FFBD', border: '#79B65F' },
  ]

  let backgroundColor, borderColor

  if (cvr <= gradientPoints[0].value) {
    backgroundColor = gradientPoints[0].bg
    borderColor = gradientPoints[0].border
  } else if (cvr >= gradientPoints[gradientPoints.length - 1].value) {
    backgroundColor = gradientPoints[gradientPoints.length - 1].bg
    borderColor = gradientPoints[gradientPoints.length - 1].border
  } else {
    for (let i = 0; i < gradientPoints.length - 1; i++) {
      const current = gradientPoints[i]
      const next = gradientPoints[i + 1]

      if (cvr >= current.value && cvr <= next.value) {
        const factor = (cvr - current.value) / (next.value - current.value)
        backgroundColor = interpolateColor(current.bg, next.bg, factor)
        borderColor = interpolateColor(current.border, next.border, factor)
        break
      }
    }
  }

  return {
    styles: {
      ...rowStyles.cvrBadge,
      backgroundColor,
      border: `1px solid ${borderColor}`,
    },
    cvr,
  }
}

export const getWeatherCondition = ({ weather, time }) => {
  if (!weather) {
    return null
  }

  if (weather.hours) {
    const findedWeatherByHours = weather.hours.find(
      item => item.datetime === time,
    )
    if (findedWeatherByHours) {
      return findedWeatherByHours.conditions
    } else {
      return weather.conditions
    }
  }

  return weather.conditions || null
}

export const getWeatherMessage = ({ condition, isSheltered }) => {
  if (isSheltered) {
    return null
  }

  if (!GOOD_WEATHER_CONDITIONS.includes(condition)) {
    return (
      <div>
        <strong>Weather warning</strong> <br />
        {condition} is forecasted for this outdoor location.
        <br />
        Mission performance may be affected <br />— consider choosing a
        different time or place.
      </div>
    )
  }
}
